module.exports = __webpack_public_path__ + "static/img/sc.c280e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/sc.png
// module id = LD1D
// module chunks = 18